import type React from 'react';
import styled from 'styled-components';
import { Box, font } from '@lemonade-hq/cdk';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis';
import Tweener from '../GivebackShared/Tweener';
import GivebackInitialTitle from '../GivebackShared/GivebackInitialTitle';
import Giveback2021RisingNumbers from './Giveback2021RisingNumbers';
import { riseTween } from '../Giveback2020/Giveback2020Animations';
import { SCROLL_RATIO } from './giveback2021Consts';

const Container = styled(Box)`
  text-align: center;
  margin: 0 auto;
  padding: 0 10px;
  z-index: 2;

  ${MEDIA_QUERIES.mobile`
        letter-spacing: -2px;
        ${font('main', { fontSize: '46px', lineHeight: 1, fontWeight: 900 })};
    `}

  ${MEDIA_QUERIES.tabletAndDesktop`
        max-width: 1044px;
        letter-spacing: -4px;
        ${font('main', { fontSize: '130px', lineHeight: 1, fontWeight: 900 })};
    `};
`;

const Title = styled(Box)`
  width: 100%;
  user-select: none;
`;

const Giveback2021Title: React.FC<{ t: number; presentationMode: boolean }> = ({ t, presentationMode }) => {
  return (
    <Container>
      <Giveback2021RisingNumbers mb={[10, 16, 16]} height={[53.375, 152.8, 152.8]} />
      {!presentationMode && (
        <>
          <Tweener
            t={t}
            tt={[
              [0.0015 * SCROLL_RATIO, 0.01 * SCROLL_RATIO],
              [0.0057 * SCROLL_RATIO, 0.0175 * SCROLL_RATIO],
              [0.0057 * SCROLL_RATIO, 0.0175 * SCROLL_RATIO],
            ]}
          >
            <GivebackInitialTitle desktopFirst mb={[12, 12, 16]} delay={1750}>
              donated by the Lemonade community to 65 nonprofits in Giveback 2021
            </GivebackInitialTitle>
          </Tweener>
          <Tweener
            t={t}
            tt={[
              [0.002 * SCROLL_RATIO, 0.0042 * SCROLL_RATIO],
              [0.0055 * SCROLL_RATIO, 0.01 * SCROLL_RATIO],
              [0.0055 * SCROLL_RATIO, 0.01 * SCROLL_RATIO],
            ]}
            allowSSR
            tween={riseTween}
          >
            <Title mb={[242, 186, 186]} height={[92, 260, 260]}>
              Here’s what that looks like:
            </Title>
          </Tweener>
        </>
      )}
    </Container>
  );
};

export default Giveback2021Title;
